// Generated using typescript-generator version null on 2017-11-13 15:01:21.

import {Observable} from "rxjs/Rx";
import {Injectable} from "@angular/core";

export class PaginationResult<T> {
  pageIndex: number;
  totalPages: number;
  totalElements: number;
  results: T[];
}
export class PaginationResultDto implements Dto {
  limitExceeded: boolean;
  pagination: PaginationResult<LigneCatalogueExamenDto>;
}

export class CatalogueExamenFiltresDto {
  locale: Locale;
  natures: NaturePrelevementDto[];
  specialites: SpecialiteExamenDto[];
  temperatures: TemperatureEnum[];
  techniques: TechniqueExamenDto[];
  tarifications: TarificationNabmDto[];
}

export class LigneCatalogueExamenDto {
  id: number;
  dateCreation: any;
  dateModification: any;
  locale: Locale;
  titre: string;
  sousTitre: string;
  nature: string;
  volume: string;
  temperature: TemperatureEnum;
  technique: string;
  frequence: string;
  delai: number;
  codesNabm: string;
  cotationsNabm: string;
  prixHorsNomenclature: number;
  specialite: string;
  prixFixe: boolean;
  creatinine: boolean;
  ententePrealable: boolean;
  consentement: boolean;
  conditionsTarifaires: string;
  synonymes: string[];
  url: string;
  lienGuide: string;
  commentaires: string;
  identifiantLcds: number;
  codeOpenlab: string;
  bioRespondable: string;
  favori: boolean;
  miseAJourRecente: boolean;
}

export class ExportDto implements Dto {
  ids: number[];
}

export class Response implements AutoCloseable {
  mediaType: MediaType;
  entity: any;
  lastModified: Date;
  date: Date;
  headers: any;
  statusInfo: StatusType;
  metadata: any;
  status: number;
  stringHeaders: any;
  allowedMethods: string[];
  cookies: { [index: string]: NewCookie };
  entityTag: EntityTag;
  links: Link[];
  length: number;
  language: Locale;
  location: URI;
}

export class CorrespondantDetailsDto {
  code: string;
  nom: string;
  adressePrincipale: AdresseDto;
  adresseLivraison: AdresseDto;
  telephone: string;
  fax: string;
  email: string;
  numFiness: string;
  numAdeli: string;
  codeRpps: string;
  typeCarte: string;
  correspondantParent: string;
}

export class UserInformations {
  id?: string;
  login?: string;
  prenom?: string;
  nom?: string;
  telephone?: string;
  role?: UserRole;
  metadata?: { [index: string]: any };
  lang?: Locale;
  modules?: string[];
  correspondants?: Correspondant[];
  date?: any;
  expires?: any;
  origine?: string;
  url?: string;
  codeRpps?: string;
  properties?: { [index: string]: any };
  'e-mail'?: string;
  daysBeforeExpire: number | undefined | null;
  firstConnection: boolean | undefined | null;
}

export class Profil {
  id?: number;
  libelle?: string;
  champs?: string;
}

export class Locale implements Cloneable, Serializable {
}

export class PaginateRequestDto {
  pageIndex: number;
  nbElementsParPage: number;
}

export class RechercheExamenDto extends PaginateRequestDto implements Dto {
  favori: boolean = false;
  examen: string;
  lettre: string;
  natures: Array<NaturePrelevementDto>;
  specialites: Array<SpecialiteExamenDto>;
  techniques: Array<TechniqueExamenDto>;
  temperatures: Array<TemperatureEnum>;
  tarifications: Array<String>;
}

export class RechercheMiseAjourDto extends PaginateRequestDto implements Dto {
  debut: Date;
  fin: Date;
  examen: Array<string>;
  modifications: Array<TypeModificationEnum>;
}

export class RechercheWithHighlightDto {
  termsToHighlight: string;
  rechercheExamenDto: RechercheExamenDto;
}

export class NaturePrelevementDto implements Dto {
  id: number;
  locale: Locale;
  libelle: string;
}

export class SpecialiteExamenDto implements Dto {
  id: number;
  locale: Locale;
  code: number;
  libelle: string;
}

export class TechniqueExamenDto implements Dto {
  id: number;
  locale: Locale;
  libelle: string;
}

export class TarificationNabmDto implements Dto {
  id: number;
  locale: Locale;
  code: string;
  libelle: string;
}

export class LigneCatalogueExamenLightDto {
  id: number;
  locale: Locale;
  titre: string;
  sousTitre: string;
  codeOpenlab: string;
}

export interface Dto {
}

export class MiseAJourDto implements Dto {
  dateModification: any;
  id: number;
  titre: string;
  sousTitre: string;
  nature: string;
  lignes: LigneMiseAJourDto[];
  referenceAnalyse: number;
}

export class GedFileDescription {
  url: string;
  nom: string;
  locale: Locale;
}

export class MediaType {
  type: string;
  subtype: string;
  parameters: { [index: string]: string };
  wildcardType: boolean;
  wildcardSubtype: boolean;
}

export interface StatusType {
  family: Family;
  statusCode: number;
  reasonPhrase: string;
}

export class Cookie {
  name: string;
  value: string;
  version: number;
  path: string;
  domain: string;
}

export class NewCookie extends Cookie {
  comment: string;
  maxAge: number;
  expiry: Date;
  secure: boolean;
  httpOnly: boolean;
}

export class EntityTag {
  value: string;
  weak: boolean;
}

export class Link {
  rel: string;
  uriBuilder: UriBuilder;
  rels: string[];
  uri: URI;
  params: { [index: string]: string };
  title: string;
  type: string;
}

export class URI implements Comparable<URI>, Serializable {
}

export interface AutoCloseable {
}

export class AdresseDto {
  ligne1: string;
  ligne2: string;
  ligne3: string;
  codePostal: string;
  ville: string;
  pays: string;
}

export class CorrespondantDto implements Dto {
  code: string;
  nom: string;
  tags: string[];
}

export class Correspondant {
  code: string;
  nom: string;
  tags: string[];
  dateDesactivation: any;
  metadata: { [index: string]: any };
}

export interface Cloneable {
}

export interface Serializable {
}

export class LigneMiseAJourDto implements Dto {
  valeurInitiale: string;
  valeurModifiee: string;
  typeModification: TypeModificationEnum;
}

export class UriBuilder {
}

export interface Comparable<T> {
}

export abstract class HttpClient {

  abstract request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any>;
}

@Injectable()
export class IAuditWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /info
   * Response code 200 - Le log a Ã©tÃ© ajoutÃ© avec succÃ¨s
   * Response code 500 - Erreur interne lors du log d'audit
   * HTTP POST /audit/info
   * Java method: fr.cerba.digicerba.authentification.webservices.audit.IAuditWebService.info
   */
  info(queryParams?: { url?: string; message?: string; }): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`audit/info`, queryParams: queryParams});
  }
}

@Injectable()
export class ICatalogueExamenWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * rechercher
   * Response code 200 -
   * HTTP POST /catalogueexamen/rechercher
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.catalogueexamen.ICatalogueExamenWebService.catalogueExamen
   */
  catalogueExamen(arg0: RechercheExamenDto): RestResponse<PaginationResultDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`catalogueexamen/rechercher`, data: arg0});
  }


  /**
   * rechercherExport
   * Response code 200 -
   * HTTP POST /catalogueexamen/rechercherExport
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.catalogueexamen.ICatalogueExamenWebService.catalogueExamenExport
   */
  catalogueExamenExport(arg0: RechercheExamenDto): RestResponse<LigneCatalogueExamenDto[]> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`catalogueexamen/rechercherExport`, data: arg0});
  }

  /**
   * rechercher
   * Response code 200 -
   * HTTP GET /catalogueexamen/all/light
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.catalogueexamen.ICatalogueExamenWebService.catalogueExamenLight
   */
  catalogueExamenLight(): RestResponse<LigneCatalogueExamenLightDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`catalogueexamen/all/light`});
  }

  /**
   * récupérer les filtres
   * Response code 200 -
   * HTTP GET /catalogueexamen/filtres
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.catalogueexamen.ICatalogueExamenWebService.filtres
   */
  catalogueExamenFiltre(): RestResponse<CatalogueExamenFiltresDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`catalogueexamen/filtres`});
  }

  /**
   * {id}
   * Response code 200 -
   * HTTP GET /catalogueexamen/{id}
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.catalogueexamen.ICatalogueExamenWebService.detailExamen
   */
  detailExamen(id: number): RestResponse<LigneCatalogueExamenDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`catalogueexamen/${id}`});
  }

  /**
   * {id}
   * Response code 200 -
   * HTTP GET /catalogueexamen/lcsd-{id}
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.catalogueexamen.ICatalogueExamenWebService.detailExamenByLcsd
   */
  detailExamenByLcsd(idLcsd: number): RestResponse<LigneCatalogueExamenDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`catalogueexamen/lcsd-${idLcsd}`});
  }

  /**
   * exportLight
   * Response code 200 - Export terminÃ©
   * HTTP POST /catalogueexamen/exportLight
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.catalogueexamen.ICatalogueExamenWebService.exportCatalogueExamen
   */
  exportCatalogueExamen(arg1: number[]): RestResponse<void> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`catalogueexamen/exportLight`,
      data: arg1
    });
  }

  /**
   * import
   * Response code 200 - Import terminÃ©
   * HTTP GET /catalogueexamen/import
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.catalogueexamen.ICatalogueExamenWebService.importCatalogueExamen
   */
  importCatalogueExamen(): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`catalogueexamen/import`});
  }

  /**
   * {id}/mail
   * Response code 200 -
   * HTTP GET /catalogueexamen/{id}/mail
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.catalogueexamen.ICatalogueExamenWebService.mailDetailExamen
   */
  mailDetailExamen(id: number): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`catalogueexamen/${id}/mail`});
  }
}

@Injectable()
export class IFavorisWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * ajout
   * Response code 200 - Favori ajoutÃ©
   * HTTP GET /favoris/ajout/{id}
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.catalogueexamen.IFavorisWebService.ajoutFavori
   */
  ajoutFavori(id: number): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`favoris/ajout/${id}`});
  }

  /**
   * supression
   * Response code 200 - Favori supprimÃ©
   * HTTP GET /favoris/suppression/{id}
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.catalogueexamen.IFavorisWebService.supressionFavori
   */
  supressionFavori(id: number): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`favoris/suppression/${id}`});
  }
}

@Injectable()
export class IMiseAJourExamenWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * export
   * Response code 200 - Export terminÃ©
   * HTTP POST /miseajourexamen/export
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.miseajour.IMiseAJourExamenWebService.exportMisesAJour
   */
  exportMisesAJour(arg0: ExportDto): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`miseajourexamen/export`, data: arg0});
  }

  /**
   * import
   * Response code 200 - Import terminÃ©
   * HTTP GET /miseajourexamen/import
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.miseajour.IMiseAJourExamenWebService.importMisesAJour
   */
  importMisesAJour(): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`miseajourexamen/import`});
  }

  /**
   * all
   * Response code 200 -
   * HTTP GET /miseajourexamen/all
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.miseajour.IMiseAJourExamenWebService.misesAJour
   */
  misesAJour(): RestResponse<MiseAJourDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`miseajourexamen/all`});
  }

  /**
   * search
   * Response code 200 -
   * HTTP GET /miseajourexamen/search
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.miseajour.IMiseAJourExamenWebService.searchMisesAJour
   */
  searchMisesAJour(arg0: RechercheMiseAjourDto): RestResponse<PaginationResult<MiseAJourDto>> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`miseajourexamen/search`, data: arg0});
  }

  /**
   * notify
   * Response code 200 - Notification terminÃ©
   * HTTP GET /miseajourexamen/notify
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.miseajour.IMiseAJourExamenWebService.notifyMisesAJour
   */
  notifyMisesAJour(): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`miseajourexamen/notify`});
  }
}

@Injectable()
export class INotificationCatalogueExamenWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * count
   * Response code 200 - Retourne les notifications de mises Ã  jour examen
   * Response code 500 - Impossible de retourner les notifications
   * HTTP GET /notification/count
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.notifications.INotificationCatalogueExamenWebService.countNotificationsMisesAjour
   */
  countNotificationsMisesAjour(): RestResponse<number> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/count`});
  }

  /**
   * read
   * Response code 200 - Marque les notifications comme lues
   * Response code 500 - Impossible de marquer les notifications
   * HTTP GET /notification/read
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.notifications.INotificationCatalogueExamenWebService.markAsReadMisesAJour
   */
  markAsReadMisesAJour(): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/read`});
  }
}

@Injectable()
export class IReferentielWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * types-modifications
   * Response code 200 -
   * HTTP GET /referentiel/types-modifications
   * Java method: fr.cerba.digicerba.catalogueexamen.webservices.referentiel.IReferentielWebService.typesModification
   */
  typesModification(): RestResponse<TypeModificationEnum[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`referentiel/types-modifications`});
  }
}

@Injectable()
export class IGedWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /search
   * Response code 204 - *Retourne la liste des fichiers associÃ©s Ã  un tag
   * HTTP GET /ged/search
   * Java method: fr.cerba.digicerba.ged.webservices.IGedWebService.searchFiles
   */
  searchFilesByIdLigneCatalogueExamen(queryParams?: { idLigneCatalogueExamen?: number; }): RestResponse<GedFileDescription[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`ged/searchDocument`, queryParams: queryParams});
  }

  searchFilesByTag(queryParams?: { tag?: string; }): RestResponse<GedFileDescription[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`ged/searchDocumentByTag`, queryParams: queryParams});
  }
}

@Injectable()
export class IRessourceMultimediaWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /{id}
   * Response code 200 - Ressource multimedia rÃ©cupÃ©rÃ©e avec succÃ¨s
   * Response code 422 - Id null ou inconnu
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration du contenu
   * HTTP GET /ressourcemultimedia/{id}
   * Java method: fr.cerba.digicerba.resourcemultimedia.webservices.IRessourceMultimediaWebService.getRessourceMultimedia
   */
  getRessourceMultimedia(id: number): RestResponse<Response> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`ressourcemultimedia/${id}`});
  }
}

@Injectable()
export class ICorrespondantWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /
   * Response code 200 - Retourne le dÃ©tail des infos d'un correspondant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/{code}/details
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondantDetails
   */
  getCorrespondantDetails(code: string): RestResponse<CorrespondantDetailsDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/${code}/details`});
  }

  /**
   * /
   * Response code 200 - Retourne la liste des correspondant de l'utilisateur courant avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/all`});
  }

  /**
   * /tags
   * Response code 200 - Retourne les tags du correspondant courant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/tags
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getTags
   */
  getTags(): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/tags`});
  }
}

@Injectable()
export class INotificationsCommonWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * messages/count
   * HTTP GET /notification/messages/count
   * Java method: fr.cerba.digicerba.shared.webservices.user.INotificationsCommonWebService.countMessageNotifications
   */
  countMessageNotifications(): RestResponse<number> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/messages/count`});
  }
}

@Injectable()
export class ITechnicWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /correspondant/all
   * Response code 200 - Retourne les correspondants actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/correspondants/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/correspondants/all`});
  }

  /**
   * /tags/all
   * Response code 200 - Retourne les tags actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getTags
   */
  getTags(queryParams?: { locale?: string; }): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/tags/all`, queryParams: queryParams});
  }
}

@Injectable()
export class IUserInformationsWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /check
   * Response code 200 - Retourne true si le module est accessible
   * Response code 401 - Le module n'est pas accessible
   * HTTP GET /check
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.checkAccess
   */
  checkAccess(): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`check`});
  }

  /**
   * /
   * Response code 200 - Retourne les informations de l'utilisateur avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /me
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.me
   */
  me(): RestResponse<UserInformations> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`me`});
  }
}

export type RestResponse<R> = Observable<R>;

export type TemperatureEnum = 'AMBIANT' | 'REFRIGERE' | 'CONGELE';

export type TypeModificationEnum =
  'TITRE'
  | 'STITRE'
  | 'NATURE'
  | 'TEMP'
  | 'TECH'
  | 'VOLUME'
  | 'FREQ'
  | 'DELAI'
  | 'NABM'
  | 'COTATION'
  | 'HN'
  | 'PFIXE'
  | 'CTARIF'
  | 'PREANA'
  | 'SUPP';

export type UserRole =
  'COMPTE_LIE'
  | 'INVITE'
  | 'ANCIEN_COMPTE'
  | 'ADMINISTRATEUR'
  | 'RESPONSABLE'
  | 'MODULE'
  | 'PROSPECT';

export type Family = 'INFORMATIONAL' | 'SUCCESSFUL' | 'REDIRECTION' | 'CLIENT_ERROR' | 'SERVER_ERROR' | 'OTHER';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = '/catalogue-examen/api/';
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/common/resources/resources.ts